import axios from "axios";

// Setup global response interceptor for Axios
export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const originalRequest = error.config;

      // Handle 401 Unauthorized / Session Expired
      if (error.response && error.response.status === 401) {
        // Skip redirect for login endpoints so user can see invalid credentials error
        const isLoginEndpoint =
          originalRequest?.url?.includes("/auth/login") ||
          originalRequest?.url?.includes("/auth/admin-login");

        if (!isLoginEndpoint) {
          const currentPath = window.location.pathname;
          localStorage.removeItem("login");

          if (!currentPath.includes("/login")) {
            alert("Your session has expired. Please log in again.");
            if (currentPath.startsWith("/admin")) {
              window.location.href = "/admin/login";
            } else {
              window.location.href = "/login";
            }
          }
        }
      }

      return Promise.reject(error);
    }
  );
};
